<template>
	<div class="widget-wrapper">
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'PostSmtpWidget',

	data: ( vm ) => ( {
		plugin_dir_url: vm.$parent.plugin_dir_url,
		admin_url: vm.$parent.admin_url,
	} ),
}
</script>

<style scoped>
.widget-wrapper {
	border: 1px solid #DCDFE5;
	margin-bottom: 24px;
	padding: 20px 0 0 24px;
	border-radius: 4px;
}

.widget-wrapper:last-child {
	margin-bottom: 0;
}
</style>